export const deepClone = <T>(data: T): T => {
  if (!data) {
    return data
  }
  return JSON.parse(JSON.stringify(data)) as unknown as T
}

export function dlv(
  obj: Record<string | number, any>,
  key: string | Array<string | number>,
  def?: any,
  p?: number,
  undef?: undefined,
) {
  key = typeof key === 'string' && key.split ? key.split('.') : key
  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef
  }
  return obj === undef ? def : obj
}

// export { dset } from 'dset'

export const removeEmpty = <T extends Record<PropertyKey, any>>(obj: T) => {
  const result: Record<PropertyKey, any> = {}
  for (const [key, value] of Object.entries(obj)) {
    if (value !== null && value !== undefined) {
      result[key] = value
    }
  }

  return result as T
}

export const removeEmptyAndSort = <T extends object>(
  iterable: T,
  strict = true,
): T => {
  if (Array.isArray(iterable)) {
    return iterable
      .filter((v) => v !== null && v !== undefined && (strict || Boolean(v)))
      .map((v) => (v && typeof v === 'object' ? removeEmptyAndSort(v) : v))
      .sort() as unknown as T
  }

  const tmp = Object.entries(iterable)
    .sort(([a], [b]) => a.toString().localeCompare(b.toString()))
    .filter(([, v]) => v !== null && v !== undefined && (strict || Boolean(v)))
    .map(([k, v]) => [
      k,
      v && typeof v === 'object' ? removeEmptyAndSort(v) : v,
    ])

  return Object.fromEntries(tmp)
}

export const hasNonEmptyValues = (obj: Record<string, unknown>) => {
  return Object.keys(removeEmpty(obj)).length > 0
}
